import {List} from 'immutable';

import type {EmailDomainModelV1} from 'resources/GeneratedModels/EmailDomain/EmailDomainModel.v1';

export function isManagedAccount(email: string, emailDomains = List<EmailDomainModelV1>()) {
  return emailDomains.some((domain) => {
    // Ensures that "@albert.io" passes but "@albert.io12345" fails
    return email.split('@')[1] === domain.getName();
  });
}
